import { render, staticRenderFns } from "./19xiangxianwenhua.vue?vue&type=template&id=78a4fc09&scoped=true&"
import script from "./19xiangxianwenhua.vue?vue&type=script&lang=js&"
export * from "./19xiangxianwenhua.vue?vue&type=script&lang=js&"
import style0 from "./19xiangxianwenhua.vue?vue&type=style&index=0&id=78a4fc09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a4fc09",
  null
  
)

export default component.exports